import ACTIONS from ".";

export const delEdit = (data) => {
  return {
    type: ACTIONS.DEL_Edit,
    payload: data,
  };
};

export const updateEdit = (data) => {
  return {
    type: ACTIONS.UPDATE_EDIT,
    payload: data,
  };
};

export const updateIsViewed = (data) => async (dispatch) => {
  dispatch({
    type: ACTIONS.UPDATE_IS_VIEWED,
    payload: parseInt(data),
  });
};

export const is_search = (data) => async (dispatch) => {
  console.log(data);
  dispatch({
    type: ACTIONS.IS_SEARCH,
    payload: data,
  });
};
